module.exports = __webpack_public_path__ + "img/styria-druck-carinthia.e384af2e.svg";